import { render, staticRenderFns } from "./AssembliesCalendar.vue?vue&type=template&id=168e4ba3&scoped=true&"
import script from "./AssembliesCalendar.vue?vue&type=script&lang=js&"
export * from "./AssembliesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AssembliesCalendar.vue?vue&type=style&index=0&id=168e4ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e4ba3",
  null
  
)

export default component.exports